import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_12345');

function CheckoutInner(){
  const stripe = useStripe();
  const elements = useElements();
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [booking, setBooking] = useState(null);
  const [mode, setMode] = useState('deposit');
  const [promo, setPromo] = useState('');
  const [discount, setDiscount] = useState(0);

  useEffect(()=>{
    (async () => {
      const b = sessionStorage.getItem('booking');
      if(!b){
        setError('No booking found. Please start from the booking page.');
        setLoading(false);
        return;
      }
      const parsed = JSON.parse(b);
      setBooking(parsed);

      let total = parsed.total || (() => {
        const servicePrices = { basic: 75, deluxe: 150, premium: 250 };
        let t = servicePrices[parsed.serviceId] || 0;
        const extras = { pet: 25, engine: 40, headlights: 60 };
        (parsed.extras || []).forEach(id => { t += extras[id] || 0; });
        return t;
      })();

      if(promo){
        try {
          const r = await fetch('http://localhost:4242/api/apply-promo?code=' + encodeURIComponent(promo));
          const d = await r.json();
          if(d.percent_off){ total = total * (1 - d.percent_off/100); }
          if(d.amount_off){ total = Math.max(0, total - d.amount_off/100); }
          setDiscount((parsed.total || total) - total);
        } catch(e) { console.warn('promo check failed'); }
      }

      const amount = Math.round((mode === 'full' ? total : Math.max(25, Math.round(total * 0.2))) * 100);

      fetch('http://localhost:4242/api/create-payment-intent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount, metadata: {
          serviceId: parsed.serviceId,
          extras: (parsed.extras||[]).join(','),
          date: parsed.date,
          time: parsed.time,
          email: parsed.contact?.email || '',
          name: parsed.contact?.name || '',
          phone: parsed.contact?.phone || '',
          mode,
          mobileOrDropoff: parsed.mobileOrDropoff,
          address: JSON.stringify(parsed.address||{})
        } })
      })
      .then(r => r.json())
      .then(d => { setClientSecret(d.clientSecret); setLoading(false); })
      .catch(e => { console.error(e); setError('Failed to initialize payment.'); setLoading(false); });
    })();
  }, [mode, promo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!stripe || !elements) return;

    const { error: submitError } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + '/thanks'
      }
    });
    if (submitError) setError(submitError.message);
  };

  if(loading) return <div className="container narrow"><p>Loading checkout…</p></div>;
  if(error) return <div className="container narrow"><p className="error">{error}</p></div>;
  if(!clientSecret || !booking) return null;

  return (
    <div className="container narrow">
      <h1>Secure Payment</h1>
      <div className="card">
        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
          <button className={mode==='deposit' ? 'btn primary' : 'btn'} onClick={()=>setMode('deposit')}>Pay Deposit (~20%)</button>
          <button className={mode==='full' ? 'btn primary' : 'btn'} onClick={()=>setMode('full')}>Pay in Full</button>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <input type="text" placeholder="Promo or gift card" value={promo} onChange={e=>setPromo(e.target.value)} />
          <button type="button" className="btn" onClick={()=>setMode(mode=>mode)}>Apply</button>
        </div>

        <form onSubmit={handleSubmit}>
          <PaymentElement />
          <button className="btn primary" style={{ marginTop: 16 }} disabled={!stripe}>Pay</button>
        </form>
      </div>
      <p className="muted small">All payments processed by Stripe. We never store card details.</p>
    </div>
  );
}

export default function Checkout(){
  return (
    <Elements stripe={stripePromise}>
      <CheckoutInner />
    </Elements>
  );
}
